import { create } from "zustand"

export const useSnoozeOpener = create<{ open: (() => void) | null }>()(() => ({
	open: null,
}))
